import { render } from "./MigracionCubo.vue?vue&type=template&id=43a8e1dc"
import script from "./MigracionCubo.vue?vue&type=script&lang=js"
export * from "./MigracionCubo.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__